// Who may approve or override a QC verdict.
//
// The main API's /decisions route is staff-only (is_staff or is_superuser): the
// platform has no per-campaign "can edit" role, and a brand user reading their
// own results should not also be able to overrule the AI on a compliance
// check. The server enforces it either way; this just stops the page offering
// buttons that can only fail.
export function currentUser() {
    try {
        return JSON.parse(localStorage.getItem('user')) || null;
    } catch (err) {
        return null;
    }
}

export function canDecideQc(user = currentUser()) {
    return Boolean(user && (user.is_staff || user.is_superuser));
}
